// src/components/Layout.js
import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import SideNavigationBar from './SideNavigationBar';
import TopNavbar from './TopNavbar';
import Breadcrumbs from './Breadcrumbs';
import ScrollToTopButton from './ScrollToTopButton';
import SubscriptionLockNotice from './SubscriptionLockNotice';
import { useAuth } from '../../contexts/AppContext';

export default function Layout() {
  const contentRef = useRef(null);
  const { subscriptionGate, authBootstrapError, retryFetchUserInfo, loading } = useAuth();
  const shouldShowLockNotice = subscriptionGate?.isBlocked && subscriptionGate?.billingOnly;

  return (
    <div className="flex h-screen bg-[#f3f5fb] text-slate-900">
      <SideNavigationBar />

      <div className="flex flex-grow flex-col overflow-hidden bg-[radial-gradient(circle_at_top_left,#ffffff_0%,#f7f9ff_40%,#eef2fb_100%)]">
        <TopNavbar />
        <Breadcrumbs />
        {authBootstrapError && !loading ? (
          <div className="mx-auto mt-3 w-[92%] max-w-[1380px] rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-sm">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div>
                <div className="font-semibold">Session data could not be refreshed</div>
                <div className="mt-1 text-amber-800">{authBootstrapError}</div>
              </div>
              <button
                type="button"
                onClick={retryFetchUserInfo}
                className="inline-flex items-center justify-center rounded-xl border border-amber-300 bg-white px-4 py-2 font-medium text-amber-900 transition hover:bg-amber-100"
              >
                Retry
              </button>
            </div>
          </div>
        ) : null}
        {shouldShowLockNotice ? <SubscriptionLockNotice /> : null}
        <ScrollToTopButton containerRef={contentRef} />

        <div
          ref={contentRef}
          className="flex-grow overflow-auto scrollbar-gutter-stable"
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}

